import { useMemo } from 'react';

export const useStepperPresenter = ({ steps: stepsProp }) => {
  const steps = useMemo(() => {
    const result = [];
    const size = stepsProp.length - 1;
    let fulfilled = false;

    for (let i = size; i >= 0; i--) {
      const { active = false, title } = stepsProp[i];
      const first = i === 0;
      const last = i === size;

      result.unshift({ active, first, fulfilled, key: `step-${i}`, last, title });

      if (active) {
        fulfilled = true;
      }
    }

    return result;
  }, [stepsProp]);

  return { steps };
};
